import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useGivingActionsDialogs } from '../../../GivingActionsDialogs/GivingActionsDialogsProvider'

import { Icon, Menu } from '@percent/lemonade'
import { GivingAction } from '@percent/partner-dashboard/services/givingActions/givingActionsService.types'

export type GivingActionsActionsMenuProps = Readonly<{
  givingAction: GivingAction
}>

export function GivingActionsActionsMenu({ givingAction }: GivingActionsActionsMenuProps) {
  const { t } = useTranslation()
  const { editGivingAction, archiveGivingAction } = useGivingActionsDialogs()

  const items = useMemo(
    () => [
      { key: 'edit', label: t('button.edit'), dataTestId: 'edit-giving-action-menu-item' },
      { key: 'archive', label: t('button.archive'), dataTestId: 'archive-giving-action-menu-item' }
    ],
    [t]
  )

  const onSelect = (key: string) => {
    switch (key) {
      case 'edit':
        editGivingAction(givingAction)
        break
      case 'archive':
        archiveGivingAction(givingAction)
        break
      default:
        break
    }
  }

  return <Menu title={<Icon name="menu-vertical" size={6} />} onSelect={onSelect} sections={[{ items }]} />
}
